import { render, staticRenderFns } from "./TabellaScarti.vue?vue&type=template&id=62dade3a&scoped=true&"
import script from "./TabellaScarti.vue?vue&type=script&lang=js&"
export * from "./TabellaScarti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dade3a",
  null
  
)

export default component.exports